;(function () {
  let multicolumnSlider

  const initSlider = (slider) => {
    // Evita re-init sullo stesso DOM
    if (slider.classList.contains('swiper-initialized')) return

    slider.classList.add('swiper')

    const wrapper = slider.querySelector('.multicolumn-list__wrapper')
    if (!wrapper) return

    wrapper.classList.add('swiper-wrapper')

    const slides = slider.querySelectorAll('.multicolumn-card')
    if (!slides || !slides.length) return
    slides.forEach((slide) => slide.classList.add('swiper-slide'))

    // Pagination esterna al container slider
    const pagination = slider.parentElement.querySelector('.multicolumn__pagination')
    // Se non c’è, esci o creane una interna (a tua scelta)
    if (!pagination) return

    multicolumnSlider = new Swiper(slider, {
      loop: false,
      slidesPerView: 1.1,
      spaceBetween: 20,
      speed: 1000,
      mousewheel: { forceToAxis: true },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true // aiuta anche a verificare il binding corretto
      }
    })
  }

  const destroySlider = (section) => {
    if (!section || !section.classList.contains('multicolumn-section')) return

    const slider  = section.querySelector('.multicolumn-slider')
    const slides  = section.querySelectorAll('.multicolumn-card')
    const wrapper = section.querySelector('.multicolumn-list__wrapper')
    if (!slider || !slides.length || !wrapper) return

    if (multicolumnSlider && typeof multicolumnSlider.destroy === 'function') {
      multicolumnSlider.destroy(true, true)
      multicolumnSlider = null
    }

    slider.classList.remove('swiper', 'swiper-initialized')
    slides.forEach((slide) => slide.classList.remove('swiper-slide'))
    wrapper.classList.remove('swiper-wrapper')
    // lascio la .multicolumn__pagination com’è; verrà riusata alla prossima init
  }

  const initMulticolumn = (section) => {
    if (!section || !section.classList.contains('multicolumn-section')) return

    const slider = section.querySelector('.multicolumn-slider')
    if (!slider) return

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576 && slider) {
          // inizializza solo se non già fatto
          if (!slider.classList.contains('swiper-initialized')) {
            initSlider(slider)
          }
        } else if (multicolumnSlider) {
          destroySlider(section)
        }
      })
    })

    sectionResizeObserver.observe(section)
  }

  if (multicolumnSlider) {
    destroySlider(document.currentScript.parentElement)
  }

  initMulticolumn(document.currentScript.parentElement)

  document.addEventListener('shopify:section:load', function (e) {
    if (multicolumnSlider) destroySlider(e.target)
    initMulticolumn(e.target)
  })
})()
